module.exports = __webpack_public_path__ + "media/images/landing/cyber/cyber-extortion-a2d85a8c15e7d498d19e5238c227af11.png";